import { CommonModule, TitleCasePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoAuthService, UserPermission } from '@techspert-io/auth';
import { IClient } from '@techspert-io/clients';
import { map, Observable } from 'rxjs';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { EnrichedUser } from '../../models/user.models';
import { UserDisplayPipe } from '../../pipes/user-display.pipe';
import { ManageUserRolesComponent } from '../manage-roles/manage-user-roles.component';
import { UserFormComponent } from '../user-form/user-form.component';

export enum EditUserTab {
  Details = 'details',
  Roles = 'roles',
}

@Component({
  selector: 'app-edit-user',
  templateUrl: 'edit-user.component.html',
  styleUrls: ['edit-user.component.scss'],
  imports: [
    CommonModule,
    MaterialModule,
    UserFormComponent,
    ManageUserRolesComponent,
    UserDisplayPipe,
    TitleCasePipe,
  ],
})
export class EditUserComponent implements OnInit {
  @Input() user: EnrichedUser;
  @Input() clients: IClient[];

  @Output() updateUserSignal = new EventEmitter();

  selectedTab$: Observable<EditUserTab>;

  isSubmitting = false;

  get canViewRoles() {
    return this.auth.loggedInUser.permissions.has(UserPermission.RolesRead);
  }

  get tabs() {
    return [
      EditUserTab.Details,
      ...(this.canViewRoles && this.user.is_active ? [EditUserTab.Roles] : []),
    ];
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private auth: CognitoAuthService
  ) {}

  ngOnInit() {
    this.selectedTab$ = this.route.queryParamMap.pipe(
      map((params) => {
        const tab =
          (params.get('tab')?.toLowerCase() as EditUserTab) ||
          EditUserTab.Details;

        if (tab === EditUserTab.Roles && !this.canViewRoles) {
          this.navigateTab(EditUserTab.Details);
        }

        return tab;
      })
    );
  }

  navigateTab(tab: string) {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab },
      queryParamsHandling: 'merge',
    });
  }

  updateUser() {
    this.updateUserSignal.emit();
  }

  handleIsSubmitting(isSubmitting: boolean) {
    this.isSubmitting = isSubmitting;
  }
}
